import 'styled-components';

export const breakpoints = {
  mobile: '320px',
  tablet: '768px',
  desktop: '1024px'
};

export const media = {
  mobile: `@media (max-width: ${breakpoints.tablet})`,
  tablet: `@media (min-width: ${breakpoints.tablet}) and (max-width: ${breakpoints.desktop})`,
  desktop: `@media (min-width: ${breakpoints.desktop})`
};

interface Theme {
  // Colors
  primary: string;
  background: string;
  surface: string;
  surfaceDark: string; // Add this
  text: string;
  textSecondary: string;
  subText: string;
  border: string;
  link: string;
  accent: string;  // Add accent color for Twitter blue etc
  
  // Interactive states
  hoverBackground: string;
  activeBackground: string;
  hoverActiveBackground: string;
  activeBorder: string;
  hoverBorder: string;
  
  // Form elements
  inputBackground: string; // Add this
  
  // Status colors
  successBackground: string;
  successText: string;
  pendingBackground: string;
  pendingText: string;
  failedBackground: string;
  failedText: string;
  defaultBackground: string;
  defaultText: string;
  errorText: string; // Add this
  
  // Table
  tableHeaderBackground: string;
  
  // Chart-specific
  chartText: string;
  chartGrid: string;
  
  // Tweet visualization
  tweet: {
    nameColor: string;
    handleColor: string;
    textColor: string;
    backgroundColor: string;
    borderColor: string;
  };
  
  // Responsive breakpoints
  mobile: string;
  tablet: string;
  desktop: string;

  // Live price line
  livePriceLine: string; // Add this property
}

declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}

export const lightTheme: Theme = {
  primary: '#F7931A', // Bitcoin orange
  background: '#F5F5F5',
  surface: '#FFFFFF',
  surfaceDark: '#F0F0F0', // Add this
  text: '#2C2C2C',
  textSecondary: '#888888',
  subText: '#666666',
  border: '#E0E0E0',
  link: '#F7931A',
  accent: '#1d9bf0',  // Twitter blue
  
  hoverBackground: '#F5F5F5',
  activeBackground: '#FFF9F0',
  hoverActiveBackground: '#FFF5E6',
  activeBorder: '#F7931A',
  hoverBorder: '#F7931A',
  
  inputBackground: '#FFFFFF', // Add this
  
  successBackground: '#E6F7E6',
  successText: '#2E7D32',
  pendingBackground: '#FFF8E1',
  pendingText: '#F57C00',
  failedBackground: '#FFEBEE',
  failedText: '#C62828',
  defaultBackground: '#E0E0E0',
  defaultText: '#757575',
  errorText: '#C62828', // Add this
  
  tableHeaderBackground: '#F7F7F7',
  
  chartText: '#666666',
  chartGrid: '#E0E0E0',
  
  tweet: {
    nameColor: '#0f1419',
    handleColor: '#536471',
    textColor: '#0f1419',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderColor: 'rgba(207, 217, 222, 0.5)'
  },
  
  mobile: '768px',
  tablet: '1024px',
  desktop: '1025px',

  livePriceLine: '#f7931a' // Match the primary color for Bitcoin
};

export const darkTheme: Theme = {
  primary: '#F7931A', // Bitcoin orange
  background: '#121212',
  surface: '#1E1E1E',
  surfaceDark: '#252525', // Add this
  text: '#E0E0E0',
  textSecondary: '#888888',
  subText: '#A0A0A0',
  border: '#333333',
  link: '#F7931A',
  accent: '#1d9bf0',  // Twitter blue
  
  hoverBackground: '#252525',
  activeBackground: '#2A2417',
  hoverActiveBackground: '#2C2519',
  activeBorder: '#F7931A',
  hoverBorder: '#F7931A',
  
  inputBackground: '#252525', // Add this
  
  successBackground: '#1E3B1E',
  successText: '#4CAF50',
  pendingBackground: '#3D3012',
  pendingText: '#FFC107',
  failedBackground: '#3B1E1E',
  failedText: '#F44336',
  defaultBackground: '#2D2D2D',
  defaultText: '#A0A0A0',
  errorText: '#F44336', // Add this
  
  tableHeaderBackground: '#252525',
  
  chartText: '#A0A0A0',
  chartGrid: '#333333',
  
  tweet: {
    nameColor: '#e7e9ea',
    handleColor: '#71767b',
    textColor: '#e7e9ea',
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    borderColor: 'rgba(83, 100, 113, 0.3)'
  },
  
  mobile: '768px',
  tablet: '1024px',
  desktop: '1025px',

  livePriceLine: '#f7931a' // Match the primary color for Bitcoin
};

export type { Theme };
